export const dataBook = {
  1: [[{ imgUrl: "img/FriendsPlus/ListPage/a.jpg", excerciseNum: 0 }]],
  2: [[{ imgUrl: "img/FriendsPlus/ListPage/2.jpg", excerciseNum: 0 }]],
  3: [[{ imgUrl: "img/FriendsPlus/ListPage/3.jpg", excerciseNum: 0 }]],
  4: [[{ imgUrl: "img/FriendsPlus/ListPage/4.jpg", excerciseNum: 0 }]],
  5: [[{ imgUrl: "img/FriendsPlus/ListPage/5.jpg", excerciseNum: 0 }]],
  6: [[{ imgUrl: "img/FriendsPlus/ListPage/6.jpg", excerciseNum: 0 }]],
  7: [[{ imgUrl: "img/FriendsPlus/ListPage/7.jpg", excerciseNum: 0 }]],
  8: [[{ imgUrl: "img/FriendsPlus/ListPage/8.jpg", excerciseNum: 0 }]],
  9: [[{ imgUrl: "img/FriendsPlus/ListPage/9.jpg", excerciseNum: 0 }]],
  10: [[{ imgUrl: "img/FriendsPlus/ListPage/10.jpg", excerciseNum: 0 }]],
  // 4: [
  //   [{ imgUrl: "img/FriendsPlus/Page4/1.jpg", excerciseNum: 0 }],
  //   [{ imgUrl: "img/FriendsPlus/Page4/2.jpg", excerciseNum: 1 }],
  //   [{ imgUrl: "img/FriendsPlus/Page4/3.jpg", excerciseNum: 2 }],
  //   [{ imgUrl: "img/FriendsPlus/Page4/4.jpg", excerciseNum: 0 }],
  // ],
  // 5: [
  //   [{ imgUrl: "img/FriendsPlus/Page5/1.jpg", excerciseNum: 0 }],
  //   [{ imgUrl: "img/FriendsPlus/Page5/2.jpg", excerciseNum: 3 }],
  //   [{ imgUrl: "img/FriendsPlus/Page5/3.jpg", excerciseNum: 4 }],
  //   [{ imgUrl: "img/FriendsPlus/Page5/4.jpg", excerciseNum: 5 }],
  //   [{ imgUrl: "img/FriendsPlus/Page5/5.jpg", excerciseNum: 0 }],
  // ],
  // 6: [
  //   [{ imgUrl: "img/FriendsPlus/Page6/1.jpg", excerciseNum: 0 }],
  //   [{ imgUrl: "img/FriendsPlus/Page6/2.jpg", excerciseNum: 1 }],
  //   [{ imgUrl: "img/FriendsPlus/Page6/3.jpg", excerciseNum: 2 }],
  //   [{ imgUrl: "img/FriendsPlus/Page6/4.jpg", excerciseNum: 0 }],
  // ],
  // 7: [
  //   [{ imgUrl: "img/FriendsPlus/Page7/1.jpg", excerciseNum: 0 }],
  //   [{ imgUrl: "img/FriendsPlus/Page7/2.jpg", excerciseNum: 3 }],
  //   [{ imgUrl: "img/FriendsPlus/Page7/3.jpg", excerciseNum: 4 }],
  //   [{ imgUrl: "img/FriendsPlus/Page7/4.jpg", excerciseNum: 0 }],
  //   [{ imgUrl: "img/FriendsPlus/Page7/5.jpg", excerciseNum: 1 }],
  //   [{ imgUrl: "img/FriendsPlus/Page7/6.jpg", excerciseNum: 0 }],
  // ],
  // 8: [
  //   [{ imgUrl: "img/FriendsPlus/Page8/1.jpg", excerciseNum: 0 }],
  //   [{ imgUrl: "img/FriendsPlus/Page8/2.jpg", excerciseNum: 1 }],
  //   [{ imgUrl: "img/FriendsPlus/Page8/3.jpg", excerciseNum: 2 }],
  //   [{ imgUrl: "img/FriendsPlus/Page8/4.jpg", excerciseNum: 0 }],
  // ],

  // 9: [
  //   [{ imgUrl: "img/FriendsPlus/Page9/1.jpg", excerciseNum: 0 }],
  //   [{ imgUrl: "img/FriendsPlus/Page9/2.jpg", excerciseNum: 2 }],
  //   [{ imgUrl: "img/FriendsPlus/Page9/3.jpg", excerciseNum: 0 }],
  //   [{ imgUrl: "img/FriendsPlus/Page9/4.jpg", excerciseNum: 1 }],
  //   [{ imgUrl: "img/FriendsPlus/Page9/5.jpg", excerciseNum: 0 }],
  // ],
  // 10: [
  //   [{ imgUrl: "img/FriendsPlus/Page10/1.jpg", excerciseNum: 0 }],
  //   [{ imgUrl: "img/FriendsPlus/Page10/2.jpg", excerciseNum: 2 }],
  //   [{ imgUrl: "img/FriendsPlus/Page10/3.jpg", excerciseNum: 0 }],
  //   [{ imgUrl: "img/FriendsPlus/Page10/4.jpg", excerciseNum: 3 }],
  //   [{ imgUrl: "img/FriendsPlus/Page10/5.jpg", excerciseNum: 0 }],
  // ],
  11: [
    [{ imgUrl: "img/FriendsPlus/Page11/1.jpg", excerciseNum: 0 }],
    [{ imgUrl: "img/FriendsPlus/Page11/2.jpg", excerciseNum: 1 }],
    [{ imgUrl: "img/FriendsPlus/Page11/3.jpg", excerciseNum: 2 }],
    [{ imgUrl: "img/FriendsPlus/Page11/4.jpg", excerciseNum: 0 }],
  ],
  12: [
    [{ imgUrl: "img/FriendsPlus/Page12/1.jpg", excerciseNum: 0 }],
    [{ imgUrl: "img/FriendsPlus/Page12/2.jpg", excerciseNum: 3 }],
    [{ imgUrl: "img/FriendsPlus/Page12/3.jpg", excerciseNum: 4 }],
    [{ imgUrl: "img/FriendsPlus/Page12/4.jpg", excerciseNum: 5 }],
    [{ imgUrl: "img/FriendsPlus/Page12/5.jpg", excerciseNum: 0 }],
  ],
  13: [
    [{ imgUrl: "img/FriendsPlus/Page13/1.jpg", excerciseNum: 0 }],
    [{ imgUrl: "img/FriendsPlus/Page13/2.jpg", excerciseNum: 1 }],
    [{ imgUrl: "img/FriendsPlus/Page13/3.jpg", excerciseNum: 2 }],
    [{ imgUrl: "img/FriendsPlus/Page13/4.jpg", excerciseNum: 0 }],
  ],
  14: [
    [{ imgUrl: "img/FriendsPlus/Page14/1.jpg", excerciseNum: 0 }],
    [{ imgUrl: "img/FriendsPlus/Page14/2.jpg", excerciseNum: 1 }],
    [{ imgUrl: "img/FriendsPlus/Page14/3.jpg", excerciseNum: 0 }],
  ],
  15: [
    [{ imgUrl: "img/FriendsPlus/Page15/1.jpg", excerciseNum: 0 }],
    [{ imgUrl: "img/FriendsPlus/Page15/2.jpg", excerciseNum: 2 }],
    [{ imgUrl: "img/FriendsPlus/Page15/3.jpg", excerciseNum: 0 }],
    [{ imgUrl: "img/FriendsPlus/Page15/4.jpg", excerciseNum: 1 }],
    [{ imgUrl: "img/FriendsPlus/Page15/5.jpg", excerciseNum: 0 }],
  ],
  16: [
    [{ imgUrl: "img/FriendsPlus/Page16/1.jpg", excerciseNum: 0 }],
    [{ imgUrl: "img/FriendsPlus/Page16/2.jpg", excerciseNum: 2 }],
    [{ imgUrl: "img/FriendsPlus/Page16/3.jpg", excerciseNum: 1 }],
    [{ imgUrl: "img/FriendsPlus/Page16/4.jpg", excerciseNum: 3 }],
    [{ imgUrl: "img/FriendsPlus/Page16/5.jpg", excerciseNum: 0 }],
  ],

  17: [[{ imgUrl: "img/FriendsPlus/ListPage/17.jpg", excerciseNum: 0 }]],
  18: [[{ imgUrl: "img/FriendsPlus/ListPage/18.jpg", excerciseNum: 0 }]],
  19: [[{ imgUrl: "img/FriendsPlus/ListPage/19.jpg", excerciseNum: 0 }]],
  20: [[{ imgUrl: "img/FriendsPlus/ListPage/20.jpg", excerciseNum: 0 }]],
  21: [[{ imgUrl: "img/FriendsPlus/ListPage/21.jpg", excerciseNum: 0 }]],
  22: [[{ imgUrl: "img/FriendsPlus/ListPage/22.jpg", excerciseNum: 0 }]],
  23: [[{ imgUrl: "img/FriendsPlus/ListPage/23.jpg", excerciseNum: 0 }]],
  24: [[{ imgUrl: "img/FriendsPlus/ListPage/24.jpg", excerciseNum: 0 }]],
  25: [[{ imgUrl: "img/FriendsPlus/ListPage/25.jpg", excerciseNum: 0 }]],
  26: [[{ imgUrl: "img/FriendsPlus/ListPage/26.jpg", excerciseNum: 0 }]],
  27: [[{ imgUrl: "img/FriendsPlus/ListPage/27.jpg", excerciseNum: 0 }]],
  28: [[{ imgUrl: "img/FriendsPlus/ListPage/28.jpg", excerciseNum: 0 }]],
  29: [[{ imgUrl: "img/FriendsPlus/ListPage/29.jpg", excerciseNum: 0 }]],

  30: [[{ imgUrl: "img/FriendsPlus/ListPage/30.jpg", excerciseNum: 0 }]],
  31: [[{ imgUrl: "img/FriendsPlus/ListPage/31.jpg", excerciseNum: 0 }]],
  32: [[{ imgUrl: "img/FriendsPlus/ListPage/32.jpg", excerciseNum: 0 }]],
  33: [[{ imgUrl: "img/FriendsPlus/ListPage/33.jpg", excerciseNum: 0 }]],
  34: [[{ imgUrl: "img/FriendsPlus/ListPage/34.jpg", excerciseNum: 0 }]],
  35: [[{ imgUrl: "img/FriendsPlus/ListPage/35.jpg", excerciseNum: 0 }]],
  36: [[{ imgUrl: "img/FriendsPlus/ListPage/36.jpg", excerciseNum: 0 }]],
  37: [[{ imgUrl: "img/FriendsPlus/ListPage/37.jpg", excerciseNum: 0 }]],
  38: [[{ imgUrl: "img/FriendsPlus/ListPage/38.jpg", excerciseNum: 0 }]],
  39: [[{ imgUrl: "img/FriendsPlus/ListPage/39.jpg", excerciseNum: 0 }]],
  40: [[{ imgUrl: "img/FriendsPlus/ListPage/40.jpg", excerciseNum: 0 }]],
  41: [[{ imgUrl: "img/FriendsPlus/ListPage/41.jpg", excerciseNum: 0 }]],
  42: [[{ imgUrl: "img/FriendsPlus/ListPage/42.jpg", excerciseNum: 0 }]],
  43: [[{ imgUrl: "img/FriendsPlus/ListPage/43.jpg", excerciseNum: 0 }]],
  44: [[{ imgUrl: "img/FriendsPlus/ListPage/44.jpg", excerciseNum: 0 }]],
  45: [[{ imgUrl: "img/FriendsPlus/ListPage/45.jpg", excerciseNum: 0 }]],
  46: [[{ imgUrl: "img/FriendsPlus/ListPage/46.jpg", excerciseNum: 0 }]],
  47: [[{ imgUrl: "img/FriendsPlus/ListPage/47.jpg", excerciseNum: 0 }]],
  48: [[{ imgUrl: "img/FriendsPlus/ListPage/48.jpg", excerciseNum: 0 }]],
  49: [[{ imgUrl: "img/FriendsPlus/ListPage/49.jpg", excerciseNum: 0 }]],
  50: [[{ imgUrl: "img/FriendsPlus/ListPage/50.jpg", excerciseNum: 0 }]],
  51: [[{ imgUrl: "img/FriendsPlus/ListPage/51.jpg", excerciseNum: 0 }]],
  52: [[{ imgUrl: "img/FriendsPlus/ListPage/52.jpg", excerciseNum: 0 }]],
  53: [[{ imgUrl: "img/FriendsPlus/ListPage/53.jpg", excerciseNum: 0 }]],
  54: [[{ imgUrl: "img/FriendsPlus/ListPage/54.jpg", excerciseNum: 0 }]],
  55: [[{ imgUrl: "img/FriendsPlus/ListPage/55.jpg", excerciseNum: 0 }]],
  56: [[{ imgUrl: "img/FriendsPlus/ListPage/56.jpg", excerciseNum: 0 }]],
  57: [[{ imgUrl: "img/FriendsPlus/ListPage/57.jpg", excerciseNum: 0 }]],
  58: [[{ imgUrl: "img/FriendsPlus/ListPage/58.jpg", excerciseNum: 0 }]],
  59: [[{ imgUrl: "img/FriendsPlus/ListPage/59.jpg", excerciseNum: 0 }]],
  60: [[{ imgUrl: "img/FriendsPlus/ListPage/60.jpg", excerciseNum: 0 }]],
  61: [[{ imgUrl: "img/FriendsPlus/ListPage/61.jpg", excerciseNum: 0 }]],
  62: [[{ imgUrl: "img/FriendsPlus/ListPage/62.jpg", excerciseNum: 0 }]],
  63: [[{ imgUrl: "img/FriendsPlus/ListPage/63.jpg", excerciseNum: 0 }]],
  64: [[{ imgUrl: "img/FriendsPlus/ListPage/64.jpg", excerciseNum: 0 }]],
  65: [[{ imgUrl: "img/FriendsPlus/ListPage/65.jpg", excerciseNum: 0 }]],
  66: [[{ imgUrl: "img/FriendsPlus/ListPage/66.jpg", excerciseNum: 0 }]],
  67: [[{ imgUrl: "img/FriendsPlus/ListPage/67.jpg", excerciseNum: 0 }]],
  68: [[{ imgUrl: "img/FriendsPlus/ListPage/68.jpg", excerciseNum: 0 }]],
  69: [[{ imgUrl: "img/FriendsPlus/ListPage/69.jpg", excerciseNum: 0 }]],
  70: [[{ imgUrl: "img/FriendsPlus/ListPage/70.jpg", excerciseNum: 0 }]],
  71: [[{ imgUrl: "img/FriendsPlus/ListPage/71.jpg", excerciseNum: 0 }]],
  72: [[{ imgUrl: "img/FriendsPlus/ListPage/72.jpg", excerciseNum: 0 }]],
  73: [[{ imgUrl: "img/FriendsPlus/ListPage/73.jpg", excerciseNum: 0 }]],
  74: [[{ imgUrl: "img/FriendsPlus/ListPage/74.jpg", excerciseNum: 0 }]],
  75: [[{ imgUrl: "img/FriendsPlus/ListPage/75.jpg", excerciseNum: 0 }]],
  76: [[{ imgUrl: "img/FriendsPlus/ListPage/76.jpg", excerciseNum: 0 }]],
  77: [[{ imgUrl: "img/FriendsPlus/ListPage/77.jpg", excerciseNum: 0 }]],
  78: [[{ imgUrl: "img/FriendsPlus/ListPage/78.jpg", excerciseNum: 0 }]],
  79: [[{ imgUrl: "img/FriendsPlus/ListPage/79.jpg", excerciseNum: 0 }]],
  80: [[{ imgUrl: "img/FriendsPlus/ListPage/80.jpg", excerciseNum: 0 }]],
  81: [[{ imgUrl: "img/FriendsPlus/ListPage/81.jpg", excerciseNum: 0 }]],
  82: [[{ imgUrl: "img/FriendsPlus/ListPage/82.jpg", excerciseNum: 0 }]],
  83: [[{ imgUrl: "img/FriendsPlus/ListPage/83.jpg", excerciseNum: 0 }]],
  84: [[{ imgUrl: "img/FriendsPlus/ListPage/84.jpg", excerciseNum: 0 }]],
  85: [[{ imgUrl: "img/FriendsPlus/ListPage/85.jpg", excerciseNum: 0 }]],
  86: [[{ imgUrl: "img/FriendsPlus/ListPage/86.jpg", excerciseNum: 0 }]],
  87: [[{ imgUrl: "img/FriendsPlus/ListPage/87.jpg", excerciseNum: 0 }]],
  88: [[{ imgUrl: "img/FriendsPlus/ListPage/88.jpg", excerciseNum: 0 }]],
  89: [[{ imgUrl: "img/FriendsPlus/ListPage/89.jpg", excerciseNum: 0 }]],
  90: [[{ imgUrl: "img/FriendsPlus/ListPage/90.jpg", excerciseNum: 0 }]],
  91: [[{ imgUrl: "img/FriendsPlus/ListPage/91.jpg", excerciseNum: 0 }]],
  92: [[{ imgUrl: "img/FriendsPlus/ListPage/92.jpg", excerciseNum: 0 }]],
  93: [[{ imgUrl: "img/FriendsPlus/ListPage/93.jpg", excerciseNum: 0 }]],
  94: [[{ imgUrl: "img/FriendsPlus/ListPage/94.jpg", excerciseNum: 0 }]],
  95: [[{ imgUrl: "img/FriendsPlus/ListPage/95.jpg", excerciseNum: 0 }]],
  96: [[{ imgUrl: "img/FriendsPlus/ListPage/96.jpg", excerciseNum: 0 }]],
  97: [[{ imgUrl: "img/FriendsPlus/ListPage/97.jpg", excerciseNum: 0 }]],
  98: [[{ imgUrl: "img/FriendsPlus/ListPage/98.jpg", excerciseNum: 0 }]],
  99: [[{ imgUrl: "img/FriendsPlus/ListPage/99.jpg", excerciseNum: 0 }]],

  100: [[{ imgUrl: "img/FriendsPlus/ListPage/100.jpg", excerciseNum: 0 }]],
  101: [[{ imgUrl: "img/FriendsPlus/ListPage/101.jpg", excerciseNum: 0 }]],
  102: [[{ imgUrl: "img/FriendsPlus/ListPage/102.jpg", excerciseNum: 0 }]],
  103: [[{ imgUrl: "img/FriendsPlus/ListPage/103.jpg", excerciseNum: 0 }]],
  104: [[{ imgUrl: "img/FriendsPlus/ListPage/104.jpg", excerciseNum: 0 }]],
  105: [[{ imgUrl: "img/FriendsPlus/ListPage/105.jpg", excerciseNum: 0 }]],
  106: [[{ imgUrl: "img/FriendsPlus/ListPage/106.jpg", excerciseNum: 0 }]],
  107: [[{ imgUrl: "img/FriendsPlus/ListPage/107.jpg", excerciseNum: 0 }]],
  108: [[{ imgUrl: "img/FriendsPlus/ListPage/108.jpg", excerciseNum: 0 }]],
  109: [[{ imgUrl: "img/FriendsPlus/ListPage/109.jpg", excerciseNum: 0 }]],
  110: [[{ imgUrl: "img/FriendsPlus/ListPage/110.jpg", excerciseNum: 0 }]],
  111: [[{ imgUrl: "img/FriendsPlus/ListPage/111.jpg", excerciseNum: 0 }]],
  112: [[{ imgUrl: "img/FriendsPlus/ListPage/112.jpg", excerciseNum: 0 }]],
  113: [[{ imgUrl: "img/FriendsPlus/ListPage/113.jpg", excerciseNum: 0 }]],
  114: [[{ imgUrl: "img/FriendsPlus/ListPage/114.jpg", excerciseNum: 0 }]],
  115: [[{ imgUrl: "img/FriendsPlus/ListPage/115.jpg", excerciseNum: 0 }]],
  116: [[{ imgUrl: "img/FriendsPlus/ListPage/116.jpg", excerciseNum: 0 }]],
  117: [[{ imgUrl: "img/FriendsPlus/ListPage/b.jpg", excerciseNum: 0 }]],

  // 98: [[{ imgUrl: 'img/FriendsPlus/ListPage/98.jpg', excerciseNum: 0 }]],
  // 99: [[{ imgUrl: 'img/FriendsPlus/ListPage/99.jpg', excerciseNum: 0 }]],
  // 100: [[{ imgUrl: 'img/FriendsPlus/ListPage/100.jpg', excerciseNum: 0 }]],
  // 101: [[{ imgUrl: 'img/FriendsPlus/ListPage/101.jpg', excerciseNum: 0 }]],
  // 102: [[{ imgUrl: 'img/FriendsPlus/ListPage/102.jpg', excerciseNum: 0 }]],
  // 103: [[{ imgUrl: 'img/FriendsPlus/ListPage/103.jpg', excerciseNum: 0 }]],
  // 104: [[{ imgUrl: 'img/FriendsPlus/ListPage/104.jpg', excerciseNum: 0 }]],
  // 105: [[{ imgUrl: 'img/FriendsPlus/ListPage/105.jpg', excerciseNum: 0 }]],
  // 106: [[{ imgUrl: 'img/FriendsPlus/ListPage/106.jpg', excerciseNum: 0 }]],
  // 107: [[{ imgUrl: 'img/FriendsPlus/ListPage/107.jpg', excerciseNum: 0 }]],
  // 108: [[{ imgUrl: 'img/FriendsPlus/ListPage/108.jpg', excerciseNum: 0 }]],
  // 109: [[{ imgUrl: 'img/FriendsPlus/ListPage/109.jpg', excerciseNum: 0 }]],
  // 110: [[{ imgUrl: 'img/FriendsPlus/ListPage/110.jpg', excerciseNum: 0 }]],
  // 111: [[{ imgUrl: 'img/FriendsPlus/ListPage/111.jpg', excerciseNum: 0 }]],
  // 112: [[{ imgUrl: 'img/FriendsPlus/ListPage/112.jpg', excerciseNum: 0 }]],
  // 113: [[{ imgUrl: 'img/FriendsPlus/ListPage/113.jpg', excerciseNum: 0 }]],
  // 114: [[{ imgUrl: 'img/FriendsPlus/ListPage/113.jpg', excerciseNum: 0 }]],
  // 115: [[{ imgUrl: 'img/FriendsPlus/ListPage/115.jpg', excerciseNum: 0 }]],
  // 116: [[{ imgUrl: 'img/FriendsPlus/ListPage/116.jpg', excerciseNum: 0 }]],
  // 117: [[{ imgUrl: 'img/FriendsPlus/ListPage/117.jpg', excerciseNum: 0 }]],
};
